/* unplugin-vue-components disabled */import script from "./setCusServiceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./setCusServiceModal.vue?vue&type=script&setup=true&lang=js"

import "./setCusServiceModal.vue?vue&type=style&index=0&id=245d0d25&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-245d0d25"]])

export default __exports__